import { Node } from "reactflow";
import {
  FEActionResourceType,
  FEConditionResourceType,
  FETriggerType,
} from "../constants/resourceTypes";
import { ServerAction, ServerCondition, ServerTask } from "./api";
import { AvailableAction } from "./routingData";

export enum NodeType {
  Trigger = "trigger",
  Action = "action",
  AutomationTask = "automationTask",
  TempNode = "tempNode",
  DefaultSettings = "defaultSettings",
}

export type TriggerCondition =
  TriggerNodeData["appliedConditions"][keyof TriggerNodeData["appliedConditions"]];

export type TriggerNodeData = {
  label: string;
  alias: string;
  frontendTriggerType?: FETriggerType;
  resourceType: string;
  isLocked: boolean;
  isConnecting: boolean;
  appliedConditions: {
    [key: string]: {
      id: string;
      // TS_TODO: add all data value for trigger conditions
      data: ServerCondition["resource_data"];
      // TS_TODO: unify with the key of RESOURCE_TYPES.conditions
      resourceType: FEConditionResourceType;
      label: string;
      // TS_TODO: add all types of trigger conditions
      type?: string;
      isLocked: boolean;
    };
  };
  availableActions?: {
    list?: AvailableAction[];
    // TS_TODO: add data type when founded as it is used in #mapActionDataToServer function
    data?: {};
  };
  connection: string | null;
  // TS_TODO: add data type for applied action
  appliedAction?: {};
};

export type JumpActionData = {
  to_action_reference: string;
};

export type BranchActionData = {
  [key: string]: {
    id: string;
    data: {
      [key: string]: {
        id: string;
        data: any;
        resourceType: FEConditionResourceType;
      };
    };
    alias: string;
  };
};

export type ActionNodeData = {
  label: string;
  alias: string;
  appliedAction: {
    // TS_TODO: add data type for appliedAction
    // data: BranchActionData | JumpActionData | {};
    data: Record<string, any>;
    label: string;
    resourceType: FEActionResourceType;
  };
  isConnecting: boolean;
  resourceType: ServerAction["resource_type"];
  connections: ServerAction["connections"];
  tasks: ServerAction["tasks"];
};

type AutomationTaskNodeData = {
  resourceType: ServerTask["resource_type"];
  actionNodeId: string;
  alias: string;
  resource_data: ServerTask["resource_data"];
};

export type TriggerNode = Node<TriggerNodeData, NodeType.Trigger>;

export type ActionNode = Node<ActionNodeData, NodeType.Action>;

export type AutomationTaskNode = Node<
  AutomationTaskNodeData,
  NodeType.AutomationTask
>;

export type TempNode = Node<{}, NodeType.TempNode>;
export type DefaultSettingsNode = Node<{}, NodeType.DefaultSettings>;

export type FlowNode = TriggerNode | ActionNode | AutomationTaskNode | TempNode;
